module.exports = __webpack_public_path__ + "static/og-image-9a89bf670a4aa762621490d1edac280a.png";